import unit from "$utils/unit/unit";
import {Queue} from "$utils/tool/queue";
import Throttle from '$utils/tool/throttle';
import {PlayerMessage} from "$utils/class/Player/const";

export default {

    inject:['getSocket'],

    data(){
      return {
          column:[],
          width:0,
          columnHeight:unit.unitPx(40)
      }
    },
    methods:{

        // 安装配置文件
        installConfig(){

            // 获取标记
            let el = this.$refs.bullet;

            /* 设置尺寸 */
            this.width = el.offsetWidth;
            this.config.height = el.offsetHeight;
            /* 设置尺寸 */

            /* 设置管道数量(取最小的管道数量) */
            let column = Math.floor(this.config.height / this.columnHeight);
            this.config.column = column > this.column.maxColumn ? this.column.maxColumn : column;
            /* 设置管道数量(取最小的管道数量) */
        },

        // 查找最近空管道
        searchEmptyColumn(createdTime){
            this.searchInvalidTrigger();
            let minTime = undefined;
            for (let i=0;i<this.config.column;i++) {

                if (this._column_last[i] === undefined) {
                    return  i;
                } else if (this._column_last[i]) {
                    let config = this._column_last[i];
                    let diff = createdTime - config.createdTime;
                    if (config.duration && diff > config.endTime) {
                        return  i;
                    } else if (config.endTime)  {
                        let useDiff = config.endTime - diff;
                        if (minTime === undefined || minTime > useDiff) {
                            minTime = useDiff;
                        }
                    }
                }

            }

            if (minTime===undefined) {
                minTime = 16;
            }



            return {
                time:minTime
            };
        },

        // 查找失效的
        searchInvalid(createdTime=0){
            createdTime = createdTime || +new Date();
            return this.column.map((item)=>{
                for (let key in item) {
                    if (item.hasOwnProperty(key) && createdTime > (item[key].createdTime + item[key].duration)) {
                        delete item[key];
                    }
                }
            });
        },

        // 触发查找失效
        searchInvalidTrigger(){
            return this.searchInvalid();
        }

    },

    mounted() {
      this.installConfig();

    },

    created() {

        // 聊天对象
        this.agoraRTMIM = this.getSocket();

        this.agoraRTMIM.on(PlayerMessage.barrage,({data})=>{
            let color = data.high == '1' ? '#fa2759' : '#fff';
            if (data.item) {

                if (data.item.is_admin) {
                    color = '#aa00a9';
                } else if (this.userInfo && data.item.user_id === this.userInfo.hash_id) {
                    color = '#72cf13'
                }
            }

            data.target_color = color;

            return this.pushQueue(data);
        })

        this.config = {
            // 列(俗称管道)
            column:0,
            // 最大列(俗称管道)
            maxColumn:5,
            // 排队对象
            queue: new Queue(),
            // 一像素滚动的时长
            duration:10,
            // 最大移动多大像素才可以被使用
            minScroll:15,
        }

        this.searchInvalidThrottle = new Throttle({
            first:false,
            call:this,
            handle: this.searchInvalidTrigger,
            type:'queueWait',
            delay:600
        });

        this.searchInvalidTrigger = this.searchInvalidThrottle.supper;
    },

    beforeUnmount() {
        this.searchInvalidThrottle && this.searchInvalidThrottle.destroy();
        this.agoraRTMIM.off(PlayerMessage.barrage);
    }

}
